import english from './english';

export default { english };
